import i18n from '../VueI18n'

/**
 *
 * @param {Object} materialGenetico Material Genetico que deve ser validado
 * @param {Array<Object>} materiaisGeneticos Lista de materiais geneticos que devem ser usados para validacao
 */
const validarMaterialGenetico = (materialGenetico, materiaisGeneticos) => {
	if (!isUnique(materialGenetico, materiaisGeneticos)) {
		return {
			isValid: false,
			message: `${i18n.t('oCodigo')} "${materialGenetico.mtge_cd_codigo}" ${i18n.t('jaPertenceAUmMaterialGenetico')}`,
		}
	}
	return { isValid: true }
}

/**
 * Valida se o material genético possui valores unicos considerando:
 * - mtge_cd_codigo
 * @param {Object} materialGenetico Material Genetico que deve ser validado
 * @param {Array<Object>} materiaisGeneticos Lista de materiais geneticos que devem ser usados para validacao
 */
function isUnique(materialGenetico, materiaisGeneticos) {
	return (
		materiaisGeneticos.filter(
			(materialGeneticoDaLista) =>
				materialGeneticoDaLista.mtge_cd_codigo === materialGenetico.mtge_cd_codigo,
		).length === 0
	)
}

export default validarMaterialGenetico
